import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import { Card, Dropdown, Form, Modal } from 'react-bootstrap';
import classNames from 'classnames';
import ChatFilterTab from './ChatFilterTab';
import DropdownSearchBox from 'components/common/DropdownSearchBox';
import { useState } from 'react';
import {
  faBars,
  faMagnifyingGlass,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from 'providers/AppProvider';

const ChatSidebar = ({ className }: { className?: string }) => {
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const {
    config: { isRTL }
  } = useAppContext();
  return (
    <>
      <Card className={classNames(className, 'chat-sidebar z-0 p-3 p-xl-1')}>
        <Button
          className="d-none d-sm-block d-xl-none mb-2"
          onClick={() => setOpenSearchModal(true)}
        >
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            className="text-body-tertiary text-opacity-85 fs-7"
          />
        </Button>
        <Form.Group className="form-icon-container mb-4 d-sm-none d-xl-block">
          <Form.Control
            type="text"
            placeholder="Search messages or dates"
            className="form-icon-input"
          />
          <FontAwesomeIcon icon={faUser} className="text-body fs-9 form-icon" />
        </Form.Group>

        <ChatFilterTab />

      </Card>
      <Modal
        show={openSearchModal}
        onHide={() => setOpenSearchModal(false)}
        className="search-box-modal mt-15"
      >
        <Modal.Body className="p-0 bg-transparent">
          <DropdownSearchBox
            placeholder="Search messages or dates"
            size="lg"
            style={{ width: 'auto' }}
            autoFocus
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ChatSidebar;
